export const RULES = [
    {
        field: 'jobTitle',
        method: 'isEmpty',
        validWhen: false,
        message: 'Vui lòng điền yêu cầu của công việc.',
    },
    {
        field: 'jobDueDate',
        method: 'isEmpty',
        validWhen: false,
        message: 'Thời hạn của công việc là bắt buộc',
    },
];